export default __webpack_public_path__ + "static/media/img_landing3.0f78ae7e.png";